import React from 'react';
import { connect } from 'react-redux';
import { setUseSemanticSearchT } from '../../../../state/actions/shared/semantic-search';
import SemanticSearchToggleView from './semantic-search-toggle-view';

const STATE_SLICES = {
  article: (state) => state.articles.article.editor,
  guide: (state) => state.guides.guide.editor,
  itinerary: (state) => state.itineraries.itinerary.editor,
  landing_page: (state) => state.landingPages.landingPage.editor,
};

const SemanticSearchToggleRedux = (props) => (
  <SemanticSearchToggleView {...props}/>
);

const mapStateToProps = (state, ownProps) => {
  const { entityId, entityType } = ownProps;
  const editor = STATE_SLICES[entityType](state);
  const currentEntity = editor[entityId];
  return {
    useSemanticSearch: currentEntity.useSemanticSearch,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId, entityType } = ownProps;
  return {
    onUseSemanticSearchChange: (bool) => dispatch(setUseSemanticSearchT(entityType, entityId, bool)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SemanticSearchToggleRedux);
